import { ConfigElement } from '../../_types';
import { ScreenProps } from '@components-common/types';
import { applySpec, propOr } from 'ramda';
import { getPageProps } from '../utils';
import { PageContainer } from '@components-common/layouts';

export const viewSpec = (cfg: ConfigElement, context: ScreenProps) => {
  const result = applySpec({
    cat: propOr('page', 'cat'),
    type: propOr('page', 'type'),

    children: (obj: any) => propOr([], 'children', obj),
    Component: (obj: any) => obj.Component || PageContainer,
    props: getPageProps,
  })(cfg);
  return result;
};

export const mapView = (obj: ConfigElement, context: any) => {
  const result = {
    cat: 'page',
    type: (obj as any).type || 'container',
    children: propOr([], 'children', obj),
    Component: propOr(PageContainer, 'Component', obj),
    props: getPageProps(obj),
  };
  return result;
};
